import { render, staticRenderFns } from "./TrusteeToTrusteeTransferFormSignature.vue?vue&type=template&id=d72b3996"
import script from "./TrusteeToTrusteeTransferFormSignature.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferFormSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports